import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
  Spinner,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllPages,
  fetchPageTableColumnNames,
  updatePagePermission,
} from "../../../slices/thunks";
import { getAuthUser } from "../../../helpers/utils";
import CommonTable from "../../../Components/Common/Table/CommonTable";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import CommonDataTable from "../../../Components/Common/Table/CommonDataTable";

function Pagepermission() {
  const dispatch = useDispatch();
  const {user} = getAuthUser();
  const location = useLocation();
  const RoleId = location.state.RoleId;

  const { t, i18n } = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");

  const { pagePermission, loading, error, pageTableColumnNames } = useSelector(
    (state) => state.Roles
  );

  const handlePermissionChange = (e, row, columnTitle) => {
    
    if (row.RoleID == user.RoleID) {
      toast.error("You cannot change the permission of this role");
      return;
    }

    const updatedRow = {
      ...row,
      [columnTitle]: e.target.checked,
    }

    dispatch(
      updatePagePermission({
        row: updatedRow,
        columnTitle,
        UserId: user.ID,
        RoleId: RoleId,
      })
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(
          fetchPageTableColumnNames({
            module: "PAGE_PERMISSION"
          })
        ).unwrap();
        await dispatch(fetchAllPages({RoleId: RoleId})).unwrap();
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [dispatch]);

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-3">
          <Col>
            <BreadCrumb
              pageTitle={t("addRole")}
              title={t("ManagePermission")}
            />
          </Col>
        </Row>

        <div className="table-responsive">
          <Card>
            {/* <CardHeader>
              <h4 className="card-title mb-0">Manage Page Permission</h4>
            </CardHeader> */}

            <CardBody>
              <div className="listjs-table" id="customerList">
                {/* <Row className="g-4 mb-3">
                  <Col className="col-sm-auto">
                    <div>
                      <Button
                        className="btn btn-soft-danger ms-2 me-2"
                        onClick={() => setDeleteModal(true)}
                        // disabled={selectedIds.length === 0}
                      >
                        <i className="ri-delete-bin-2-line"></i>
                      </Button>
                      <Button
                        color="secondary"
                        className="add-btn me-1"
                        onClick={() => handleClassesClicks("isAdd")}
                        id="create-btn"
                      >
                        <i className="ri-add-line align-bottom me-1 ms-1"></i>
                        {t("AddNew")}
                      </Button>
                    </div>
                  </Col>
                  <Col className="col-sm">
                    <div className="d-flex justify-content-sm-end">
                      <Button
                        className="btn btn-soft"
                        onClick={() => setModalOpen(true)}
                      >
                        <i className="ri-filter-3-line"></i>
                      </Button>
                      <div className="search-box ms-2 me-2">
                        <Input
                          type="text"
                          className="form-control search"
                          placeholder={t("Search")}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </Col>
                </Row> */}
                {loading ? (
                  <div className="d-flex justify-content-center align-items-center">
                    <Spinner
                      style={{ height: "3rem", width: "3rem" }}
                      className="me-2"
                    >
                      Loading...
                    </Spinner>
                  </div>
                ) : (
                  <div className="listjs-table" id="customerList">
                    <CommonDataTable
                      data={pagePermission}
                      tableColumnNames={pageTableColumnNames}
                      searchTerm={searchTerm}
                      handleCheckbox={handlePermissionChange}
                      hasAction={false}
                    />
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>
    </div>
  );
}

export default Pagepermission;
